export default "__VITE_ASSET__a243988a__"